import React from "react"
import addToMailchimp from 'gatsby-plugin-mailchimp'
import { Row, Col } from 'reactstrap'
import { OutboundLink } from 'gatsby-plugin-google-analytics'

import './forms.css'


class MailchimpForm extends React.Component {
  constructor() {
    super()
    this.state = {
      email: ``,
      TITLE: ``,
      FNAME: ``,
      LNAME: ``
    }
  }

  // Update state each time user edits their email address
  _handleEmailChange = e => {
    this.clearErrors();
    this.setState({ email: e.target.value })
  }

  _handleTitleChange= e => {
    this.clearErrors();
    this.setState({ TITLE: e.target.value })
  }
  _handleFNameChange= e => {
    this.clearErrors();
    this.setState({ FNAME: e.target.value })
  }
  _handleLNameChange= e => {
    this.clearErrors();
    this.setState({ LNAME: e.target.value })
  }
  // Post to MC server & handle its response
  _postEmailToMailchimp = (email, title, fname, lname, {pathname} ) => {
    addToMailchimp(email, {TITLE: title, FNAME: fname, LNAME: lname})
    .then(result => {
      // Mailchimp always returns a 200 response
      // So we check the result for MC errors & failures
      if (result.result !== `success`) {
        this.setState({
          status: `error`,
          msg: result.msg,
        })
      } else {
        // Email address succesfully subcribed to Mailchimp
        this.setState({
          status: `success`,
          msg: result.msg,
        })
      }
    })
    .catch(err => {
      // Network failures, timeouts, etc
      this.setState({
        status: `error`,
        msg: err,
      })
    })
  }

  _handleFormSubmit = e => {
    e.preventDefault()
    e.stopPropagation()

    this.clearErrors();

    if (this.showFormErrors() ) {
    this.setState({
        status: `sending`,
        msg: null,
      },
      // setState callback (subscribe email to MC)
      this._postEmailToMailchimp(this.state.email, this.state.TITLE, this.state.FNAME, this.state.LNAME, {
        pathname: document.location.pathname,
      })
      )}
  }

  handleChange(event) {
    let value = event.target.value;

    this.clearErrors();

    this.setState({
        [event.target.name]: value
    });
  }

  clearErrors() {
    const form = document.getElementById('email-capture');
    const inputs = form.querySelectorAll('input');
    const error = form.querySelector('#mcFormError');

    error.textContent = '';

    for (var i = 0; i < inputs.length; ++i) {
      const parent = inputs[i];
      parent.classList.remove('has-error');

    }

}

  showFormErrors() {
    const form = document.getElementById('email-capture');
    const inputs = form.querySelectorAll('input');
    const error = form.querySelector('#mcFormError');
    let errorMessages = [];
    let isFormValid = true;

    this.clearErrors();

    for (var i = 0; i < inputs.length; ++i) {

      const isInputValid = this.showInputError(inputs[i]);
      const parent = inputs[i];

      if (typeof isInputValid === 'string') {
          errorMessages.push(isInputValid);
          parent.classList.add('has-error');
          isFormValid = false;
      }

    }

    if (errorMessages.length) {
        error.innerHTML += errorMessages[0];
    }

    return isFormValid;
}

showInputError(input) {
    const name = input.name;
    const validity = input.validity;

    if (!validity.valid) {
        if (validity.valueMissing) {
          return 'Please fill in all fields';
        } else if (input.type === 'email' && (validity.typeMismatch || validity.patternMismatch) ) {
          return 'Invalid email address';
        }
    }

    return true;
}

  render() {
    return (
      <Col md="12" className="mailchimp">
        {this.state.status === `success` ? (
          <div className="success">Thank you! Youʼll receive your first email shortly.</div>
        ) : (
          <div>
            <h3>Newsletter sign up</h3>
            <p>As a subscriber to our emails we'll keep you up to date with our most recent fundraising successes, key insights and project developments.</p>
            <p>Please fill in your details below to receive our updates, we will do our best to keep communications at a minimum level, and you can unsubscribe at any time. For further details on how your data is used and stored, please see our <OutboundLink href="/JBVC_Privacy_Policy_May_2018.pdf" target='_blank' style={{textDecoration: 'underline'}}>Privacy Policy</OutboundLink>.</p>
            <form
              id="email-capture"
              method="post"
              noValidate
            >
                <input
                  type="text"
                  id="mce-TITLE"
                  name="TITLE"
                  placeholder="Title"
                  onChange={this._handleTitleChange}
                  required
                />
                <input
                  type="text"
                  id="mce-FNAME"
                  name="FNAME"
                  placeholder="First Name"
                  onChange={this._handleFNameChange}
                  required
                />
                <input
                  type="text"
                  id="mce-LNAME"
                  name="LNAME"
                  placeholder="Last Name"
                  onChange={this._handleLNameChange}
                  required
                />
                <input
                  type="email"
                  name="MERGE0"
                  placeholder="Email Address"
                  onChange={this._handleEmailChange}
                  pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$"
                  required
                />

                <div className="readMore" style={{marginTop:'15px'}} onClick={this.state.status !== 'sending' ? this._handleFormSubmit : null}>
                  Sign up
                    <div className="chevron green" />
                    <div className="chevron green" />
                </div>
                {this.state.status === `error` ? (
                  <div
                    dangerouslySetInnerHTML={{ __html: this.state.msg }}
                  />
                ) : null }
                <div id="mcFormError"></div>
            </form>
          </div>
        )}
      </Col>
    )
  }
}

export default MailchimpForm



// WEBPACK FOOTER //
// ./src/components/mailchimp-form.js